import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
const StyledContainer = styled.View`
  padding: 24px;
`;
export default function Page(props) {
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: "regular",
    color: Colors.gray500
  }, "Please enter the 6-digit verification code that we sent to", ' ', props.mobileNumber, '  ', /*#__PURE__*/React.createElement(Text.BodySmall, {
    weight: "regular",
    color: Colors.advanceBlue300,
    onPress: props.onPress
  }, "Change")));
}
Page.defaultProps = {
  mobileNumber: '',
  onPress: () => {}
};
Page.propTypes = {
  mobileNumber: PropTypes.string,
  onPress: PropTypes.func
};
//# sourceMappingURL=page.js.map